import { AriaAttributes } from 'react';
import { ILinkItem } from '@belong/types';

interface IGetAriaProps extends Pick<ILinkItem, 'aria-label' | 'a11yLabel' | 'children' | 'caption' | 'status'> {
  linkListId: string;
  position: number;
}

interface IAriaData extends Pick<AriaAttributes, 'aria-describedby' | 'aria-label' | 'aria-labelledby'> {
  contentId: string;
  labelId: string;
  statusId: string;
}

export const getAriaProps = ({
  a11yLabel,
  caption,
  children,
  linkListId,
  position,
  status,
  ...itemProps
}: IGetAriaProps): IAriaData => {
  const contentId = `${linkListId}-${position}-content`;
  const labelId = `${linkListId}-${position}-label`;
  const statusId = `${linkListId}-${position}-status`;

  const aria: IAriaData = {
    contentId,
    labelId,
    statusId
  };

  // We use either the html aria-label or a11yLabel for the aria-label
  const ariaLabel = itemProps['aria-label'] || a11yLabel;
  if (ariaLabel) {
    aria['aria-label'] = ariaLabel;
  } else {
    // Only set the labeledBy if there is no aria-label, as it will override the aria-label
    aria['aria-labelledby'] = labelId;
  }

  let ariaDescribedBy = '';
  if (children || caption) {
    ariaDescribedBy = contentId;
  }

  if (status) {
    ariaDescribedBy = `${statusId} ${ariaDescribedBy}`.trim();
  }

  // If the describedby is an empty string, fallback to undefined so it's not set the dom
  aria['aria-describedby'] = ariaDescribedBy || undefined;

  return aria;
};
